module.exports = __webpack_public_path__ + "img/new1.4d4ec037.png";